import { render, staticRenderFns } from "./VendorProfilePage.vue?vue&type=template&id=32c18202&scoped=true&"
import script from "./VendorProfilePage.vue?vue&type=script&lang=js&"
export * from "./VendorProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./VendorProfilePage.vue?vue&type=style&index=0&id=32c18202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c18202",
  null
  
)

export default component.exports